export const USER_KEY = 'user';
export const UNAUTHORIZED_MESSAGE =
  'You do not have permissions to perform this action';
export const UNAUTHORIZED_ROUTE_MESSAGE = 'This section is unauthorized';
